import axios from 'axios'
import { Decode } from '@/services'

const GetToken = () => {
  if (localStorage.getItem('oneData') !== null) {
    const oneData = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
    const auth = {
      headers: { Authorization: `Bearer ${oneData.user.access_token}` }
    }
    return auth
  } else {
    const auth = ''
    return auth
  }
}

export default {
  // GetOTP
  async GetOTP (val) {
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/get_otp_oauth`, val)
      // console.log('data', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  // ConfirmOTP
  async ConfirmOTP (val) {
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/confirm_otp_oauth`, val)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  // FindTaxID
  async FindTaxID (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/business/find_tax_id_by_one_id`, val, auth)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetOTPV2 (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/get_otp_oauth_v2`, val, auth)
      // console.log('data', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  // ConfirmOTP
  async ConfirmOTPV2 (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/confirm_otp_oauth_v2`, val, auth)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetOTPV4 (val) {
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/get_otp_oauth_v4`, val)
      // console.log('data', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ConfirmLoginOTP (val) {
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/oauth_otp_v2`, val)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async SentOTPLoginV2 (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/sent_otp_login_v2`, val, auth)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async RegisterNexGenID (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/nexgen/register_nexgen_id`, val, auth)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async LoginNexGenID (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/nexgen/login_nexgen_id`, val, auth)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async CheckPhoneUser (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/nexgen/check_phone_user`, val, auth)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async EditPIN (val) {
    try {
      let config = {}
      // ถ้ามี token ส่งมา
      if (val.token) {
        config = {
          headers: {
            Authorization: `Bearer ${val.token}`,
            'Content-Type': 'application/json'
          }
        }
      } else {
        // ใช้ auth เดิม
        config = await GetToken()
      }
      // clone object แล้วลบ token ออกจาก body
      const payload = { ...val }
      delete payload.token
      var response = await axios.post(
        `${process.env.VUE_APP_BACK_END4}api/nexgen/edit_pin`,
        payload,
        config
      )
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetOTPNexGenID (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/get_otp_nexgen_id`, val, auth)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetNexGenOTP (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/nexgen/get_nexgen_otp`, val, auth)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ConfirmNexGenOTP (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/nexgen/confirm_nexgen_otp`, val, auth)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async RegisterNexGenIDCard (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/nexgen/register_nexgen_id_card`, val, auth)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetNexGenOTPRePIN (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/nexgen/get_nexgen_otp_repin`, val, auth)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ConfirmNexGenOTPRePIN (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/nexgen/confirm_nexgen_otp_repin`, val, auth)
      // console.log('data orderlist', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }
}
